import * as tslib_1 from "tslib";
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { hot } from 'react-hot-loader/root';
import { LocaleProvider, Modal } from 'antd';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import { ThemeProvider } from 'styled-components';
import { theme } from '@/shared/styled';
import _ from 'lodash';
let Dialog = class Dialog extends Component {
    constructor() {
        super(...arguments);
        this.contentRef = React.createRef();
        this.state = {
            isLoading: false,
        };
    }
    render() {
        const className = this.props.className;
        const style = this.props.style;
        const visible = this.props.visible;
        const title = this.props.title;
        const cancelText = this.props.cancelText;
        const okText = this.props.okText;
        const closable = this.props.closable;
        const mask = this.props.mask;
        const width = this.props.width;
        const afterClose = this.props.afterClose;
        const hiddenFoot = this.props.hiddenFoot;
        const isLoading = this.state.isLoading;
        const content = React.cloneElement(this.props.content, Object.assign({}, (_.get(this.props.content, 'type.displayName', '').match(/^Form\(\w+\)/) // antd Form 组件
            ? {
                wrappedComponentRef: (current) => (this.contentRef = { current }),
            }
            : { ref: this.contentRef })));
        const onCancel = () => {
            const close = this.props.close.bind(this, { triggerCancel: true });
            if (this.contentRef &&
                this.contentRef.current &&
                this.contentRef.current.onModalCancel) {
                this.contentRef.current.onModalCancel(close);
            }
            else {
                close();
            }
        };
        const onOk = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.contentRef) {
                const cpt = this.contentRef.current;
                if (cpt) {
                    let data;
                    try {
                        const res = cpt.onModalOk && cpt.onModalOk();
                        if (res && res.then) {
                            this.setState({ isLoading: true });
                            data = yield res;
                        }
                        else {
                            data = res;
                        }
                    }
                    catch (error) {
                        console.warn(error);
                        this.setState({ isLoading: false });
                        return;
                    }
                    if (this.props.onOk) {
                        try {
                            const res2 = this.props.onOk(data);
                            if (res2 && res2.then) {
                                yield res2;
                            }
                            this.setState({ isLoading: false });
                            this.props.close();
                        }
                        catch (error) {
                            console.warn(error);
                            this.setState({ isLoading: false });
                        }
                    }
                }
            }
        });
        return (<LocaleProvider locale={zhCN}>
        <ThemeProvider theme={theme}>
          <Modal className={className} style={style} visible={visible} title={title} width={width} onCancel={onCancel} onOk={onOk} afterClose={afterClose} confirmLoading={isLoading} cancelText={cancelText} okText={okText} closable={closable} mask={mask} {...(hiddenFoot && { footer: null })}>
            {content}
          </Modal>
        </ThemeProvider>
      </LocaleProvider>);
    }
};
Dialog = tslib_1.__decorate([
    hot
], Dialog);
export default function createModal(config) {
    const divEl = document.createElement('div');
    document.body.appendChild(divEl);
    function close(...args) {
        render(Object.assign({}, config, { close, visible: false, afterClose: destroy.bind(this, ...args) }));
    }
    function destroy(...args) {
        const unmountResult = ReactDOM.unmountComponentAtNode(divEl);
        if (unmountResult && divEl.parentNode) {
            divEl.parentNode.removeChild(divEl);
        }
        const triggerCancel = args &&
            args.length &&
            _.some(args, param => param && param.triggerCancel);
        if (config.onCancel && triggerCancel) {
            config.onCancel(...args);
        }
    }
    function render(props) {
        ReactDOM.render(<Dialog {...props}/>, divEl);
    }
    render(Object.assign({}, config, { visible: true, close }));
    return {
        destroy: close,
    };
}
